import { T } from '@transifex/react';
import { Text, VStack } from '@vidahealth/vida-ui';
import { Image, View } from 'react-native';

import type { ProgramBehavior } from '@/modules/api';

/**
 * Private to ProgramOverview — the "What you'll work on" grid of behavior chips
 * (icon + title). Column count is CONTAINER-driven via container queries (not
 * viewport breakpoints), tracking the Screen's content width (min 272 → max
 * 552): 3-up at 552, 2-up from 400, and a single full-width column below that
 * (the Screen's min width) so tiles never wrap with leftover white space. Tiles
 * use a fixed fractional basis (no flex-grow) so a single behavior stays one
 * column wide at the 2- and 3-up tiers.
 */
export function BehaviorGrid({ behaviors }: { behaviors: ProgramBehavior[] }) {
  return (
    <VStack space='md'>
      <Text size='md' weight='semibold' className='text-typography-900'>
        <T _str='What you’ll work on:' />
      </Text>
      <View className='@container'>
        <View className='flex-row flex-wrap gap-4'>
          {behaviors.map((behavior) => (
            <View
              key={behavior.uuid}
              className='min-h-[96px] basis-full items-center justify-center gap-2 rounded-md bg-[#FDF6EE] px-4 py-6 @[400px]:basis-[48%] @[552px]:basis-[31%]'
            >
              {behavior.icon ? (
                <Image
                  source={{ uri: behavior.icon }}
                  resizeMode='contain'
                  className='h-10 w-10'
                  accessibilityLabel={behavior.title}
                />
              ) : null}
              <Text size='sm' className='text-center dark:text-typography-0'>
                {behavior.title}
              </Text>
            </View>
          ))}
        </View>
      </View>
    </VStack>
  );
}
